module.exports = __webpack_public_path__ + "static/media/pgSql.5ec94eed.png";